import { abi } from './contract-abi';

export const contractConfig = {
  '8217': {  // Kaia
    address: '0xA03eD8DFf60B1A2F14Ba9dda7c4cCA5354628B90',
    nftMarketUrl: 'https://opensea.io/collection/retro-fun-gbc',
    rpcUrl: 'https://public-en.node.kaia.io',
    method: 'kaia_call',
    abi,
  },
  '84532': { // Base Sepolia
    address: '0x6C76Eb7cEf01340acE87D7939A8E79790888D218',
    nftMarketUrl: 'https://testnet.rarible.com/collection/base/0x6C76Eb7cEf01340acE87D7939A8E79790888D218',
    rpcUrl: 'https://sepolia.base.org',
    method: 'eth_call',
    abi,
  },
  '1001': {  // Kaia Testnet
    address: '0xD8Bd4A0D5A33BdDf19CD3D395345e243DEAAFFe9',
    nftMarketUrl: 'https://testnets.opensea.io/collection/retro-fun-gbc-collection-2',
    rpcUrl: 'https://public-en-kairos.node.kaia.io',
    method: 'kaia_call',
    abi,
  },
} as const;

export default contractConfig; 